import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Ticket } from '@app/dtos/ticket';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ContactService {

    constructor(private readonly http: HttpClient) { }

    sendContactForm(ticket: Ticket): Observable<Ticket> {
        return this.http.post<Ticket>(`${environment.apiPath}/contacts/`, ticket);
    }
}
